export const getDisabledHintCount = ({
  isSignedIn = false,
  isPreview = false,
  hintAffordability = {},
  excludedHintKeys = [],
}) => {
  if (!isSignedIn || isPreview) {
    return 0;
  }

  const excluded = new Set(excludedHintKeys);

  return Object.entries(hintAffordability).filter(
    ([hintKey, isAffordable]) => !excluded.has(hintKey) && isAffordable === false,
  ).length;
};

export const getDisabledHintsMessage = ({ balance, disabledHintCount }) => {
  const normalizedBalance = Number.isFinite(Number(balance)) ? Number(balance) : 0;
  return `Hai ${normalizedBalance} gettoncini. Per ottenere gettoncini extra ed utilizzare gli aiutini, guarda un breve annuncio.`;
};
